import * as Parse from 'parse'
import { FunctionNames, Params, Responses } from '../../../../../server/src/shared-with-client/endpoint-definitions'
import { Objects } from '../../../../../server/src/shared-with-client/object-definitions'

export class MailingService {
    constructor() {}

    public async createInHouseFromMailingLists(
        establishmentId: string,
        clientId: string,
        mailingLists: { id: string; name: string }[],
        mailingName: string,
        options: Objects.Mailing.IFields.Options.Value,
        duplicateDelection: boolean
    ): Promise<Objects.Job.Parse<Objects.Job.ByType.Mailing.Create.FromMailingLists.Params, Objects.Job.ByType.Mailing.Create.FromMailingLists.Data>> {
        const params: Params.Mailing.CreateInHouseFromMailingLists = {
            establishmentId,
            clientId,
            mailingLists,
            mailingName,
            options,
            duplicateDelection,
        }

        const fn: FunctionNames.Mailing.CreateInHouseFromMailingLists = 'createInHouseMailingFromMailingLists'
        const response: Responses.Mailing.CreateInHouseFromMailingLists = await Parse.Cloud.run(fn, params)

        return response
    }

    public async createInHouseFromMailingOrders(
        mailingName: string,
        options: Objects.Mailing.IFields.Options.Value,
        mailingOrders: { id: string; name: string }[],
        mailablePdfCreationParams: Objects.Mailing.IFields.MailablePdfCreationParams.Value | undefined
    ): Promise<Objects.Job.Parse<Objects.Job.ByType.Mailing.Create.FromMailingOrders.Params, Objects.Job.ByType.Mailing.Create.FromMailingOrders.Data>> {
        const params: Params.Mailing.CreateInHouseFromMailingOrders = {
            mailingName,
            options,
            mailingOrders,
            mailablePdfCreationParams,
        }

        const fn: FunctionNames.Mailing.CreateInHouseFromMailingOrders = 'createInHouseMailingFromMailingOrders'
        const response: Responses.Mailing.CreateInHouseFromMailingOrders = await Parse.Cloud.run(fn, params)

        return response
    }

    public async createZendirect(mailingName: string, mailingDate: Date, mailingOrders: { id: string; name: string }[] | undefined) {
        const params: Params.Mailing.CreateZendirect = {
            mailingName,
            mailingDate,
            mailingOrders,
        }

        const fn: FunctionNames.Mailing.CreateZendirect = 'createZendirectMailing'
        const response: Responses.Mailing.CreateZendirect = await Parse.Cloud.run(fn, params)

        return response
    }
}
